import { useEffect } from "react";

import ResponseModals from "../../../../Common/Modals/components/ResponseModals";
import { useProviderServicesPermissions } from "../../hooks/useProviderServicesPermissions";
import { useResetAllStores } from "../../hooks/useResetAllStores";

import ActionButtons from "./ActionButtons";
import AvailableServices from "./AvailableServices";
import ProvidedServices from "./ProvidedServices";
import ServiceMovementButtons from "./ServiceMovementButtons";

export default function MedicalServices() {
  const { resetAllStores } = useResetAllStores();
  const {handlers} = useProviderServicesPermissions();

  useEffect(() => {
    resetAllStores();
  }, [resetAllStores]);

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col gap-1 p-1">
      <div className="flex min-h-0 flex-1 flex-row gap-1">
        <AvailableServices />
        <ServiceMovementButtons />
        <ProvidedServices />
      </div>
      <div className="flex w-full flex-row justify-end">
        <ActionButtons />
      </div>
      <ResponseModals {...handlers} />
    </div>
  );
}
